import AddBaseStationView from "@/modules/provisioning-base-station/views/AddBaseStationView.vue";
import { groupStore } from "@/modules/label-group/store/label-group";
export default {
  path: "/AddBaseStation",
  name: "AddBaseStation",
  component: AddBaseStationView,
  meta: {
    requiresAuth: true,
    roles: ["ADMIN","INSTALLER"],
  },
  beforeEnter: (to, from, next) => {
    
    groupStore.updateAllLabels();
    return next();
  },
};
